export default "__VITE_ASSET__DtycCGRa__"